import { Space } from 'antd';
import React, { useEffect, useState } from 'react';

type GEO = { city: string; region: string; country_name; org: string };

export default ({ ip }: { ip: string }) => {
  const [geo, setGeo] = useState<GEO>();

  const fetchGeo = async () => {
    const rsp = await fetch(`https://ipapi.co/${ip}/json`);
    const data = await rsp.json();
    setGeo(data);
  };

  useEffect(() => {
    if (!ip || !/(\d+\.){3}\d+/.test(ip)) {
      return;
    }
    fetchGeo();
  }, [ip]);

  if (!geo) return <>---</>;

  return (
    <Space direction="vertical" size={0}>
      <div>
        {geo.country_name} / {geo.region} / {geo.city}
      </div>
      <div>{geo.org}</div>
    </Space>
  );
};
